import { DatiqButtonSizes, DatiqButtonTypes } from '@dat/datiq-components-pkg/button';
import z from 'zod';

const IqCellMenuItemSchema = z.object({
    label: z.string(),
    icon: z.string().optional(),
    data: z.object({
        name: z.string(),
        payload: z.any().optional()
    }),
    id: z.string().optional(),
    disabled: z.boolean().optional(),
    menuHeader: z.boolean().optional(),
    tooltip: z.object({
        id: z.string().optional(),
        type: z.literal('Info'),
        title: z.string(),
        description: z.string().optional(),
        icon: z.string().optional(),
        hideIcon: z.boolean().optional(),
        openOnClick: z.boolean().optional()
    }).optional(),
    showToolTip: z.boolean().optional(),
    props: z.unknown().optional()
});

const IqMenuTriggerSchema = z.object({
    id: z.string().optional(),
    props: z.unknown().optional()
});

export const IqCellMenuSchema = z.object({
    id: z.string().optional(),
    type: z.enum(['Icon', 'Button']),
    items: z.array(IqCellMenuItemSchema),
    icon: z.string().optional(),
    trigger: IqMenuTriggerSchema.optional(),
    disabled: z.boolean().optional(),
    button: z.object({
        id: z.string(),
        type: z.nativeEnum(DatiqButtonTypes),
        size: z.nativeEnum(DatiqButtonSizes).optional(),
        label: z.string(),
        props: z.unknown().optional(),
        disabled: z.boolean().optional(),
        icon: z.string().optional()
    }).optional(),
    menuClass: z.string().optional()
});

export type IDatiqCellMenuItem = z.infer<typeof IqCellMenuItemSchema>;
export type IDatiqCellMenu = z.infer<typeof IqCellMenuSchema>;
